<div class="wrapper wrapper-full-page">

          <router-outlet></router-outlet>
</div>
